import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from './../../types/entity';
import { AuthProvider, AuthProviderMarshaller } from '../enums/AuthProvider';

export type UserExternalAuth = Entity<IUserExternalAuth>;
export interface IUserExternalAuth extends IEntity {
  attributes: {
    id: EntityStringId;
    uid: string;
    authProvider: AuthProvider;
  };
}

// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserExternalAuth: IEntityType<IUserExternalAuth> = vmClient.defineClass({
  typeName: 'UserExternalAuth',
  version: 1,
  persisted: true,
  attributes: {
    uid:           'string',
    authProvider: {
      type: AuthProvider,
      notNull: true,
      marshaller: AuthProviderMarshaller,
    },
  },
  associations: {},
});
